import type {
  CollectionName,
  SeriesName,
  TechniqueSeason,
} from "@root/constants";

export const mapFromCollectionNameToSeasonName: Record<
  string,
  TechniqueSeason
> = {
  essentials: "season-1",
  "inner-pleasure": "season-2",
  "toy-pleasure": "season-3",
};

export const mapFromCollectionNameToSeriesName: Record<
  CollectionName,
  SeriesName
> = {
  essentials: "series1",
  "inner-pleasure": "series2",
  "toy-pleasure": "series3",
};
